<div class="flex items-stretch grow shrink-0 justify-center my-5" id="sidebar_menu">
	<div class="kt-scrollable-y-auto grow" data-kt-scrollable="true" data-kt-scrollable-dependencies="#sidebar_header, #sidebar_footer" data-kt-scrollable-height="auto" data-kt-scrollable-offset="0px" data-kt-scrollable-wrappers="#sidebar_menu" data-kt-scrollable-initialized="true" style="height: 1047px;">
		<!-- Primary Menu -->
		<div class="kt-menu flex flex-col w-full gap-1.5 px-3.5" data-kt-menu="true" data-kt-menu-accordion-expand-all="false" id="sidebar_primary_menu">
			<div class="kt-menu-item active">
				<a class="kt-menu-link gap-2.5 py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
					<span class="kt-menu-icon items-start text-lg text-secondary-foreground kt-menu-item-active:text-foreground kt-menu-item-here:text-foreground kt-menu-item-show:text-foreground kt-menu-link-hover:text-foreground dark:menu-item-active:text-mono dark:menu-item-here:text-mono dark:menu-item-show:text-mono dark:menu-link-hover:text-mono">
						<i class="ki-filled ki-home-3">
						</i>
					</span>
					<span class="kt-menu-title text-sm text-foreground font-medium kt-menu-item-here:text-mono kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
						Overview
					</span>
				</a>
			</div>
			<div class="kt-menu-item kt-menu-item-accordion" data-kt-menu-item-toggle="accordion" data-kt-menu-item-trigger="click">
				<div class="kt-menu-link gap-2.5 py-2 px-2.5 rounded-md border border-transparent">
					<span class="kt-menu-icon items-start text-secondary-foreground text-lg kt-menu-item-here:text-foreground kt-menu-item-show:text-foreground kt-menu-link-hover:text-foreground dark:menu-item-here:text-mono dark:menu-item-show:text-mono dark:menu-link-hover:text-mono">
						<i class="ki-filled ki-profile-circle">
						</i>
					</span>
					<span class="kt-menu-title font-medium text-sm text-foreground kt-menu-item-here:text-mono kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
						Public Profile
					</span>
					<span class="kt-menu-arrow text-muted-foreground kt-menu-item-here:text-foreground kt-menu-item-show:text-foreground kt-menu-link-hover:text-foreground">
						<span class="inline-flex kt-menu-item-show:hidden">
							<i class="ki-filled ki-down text-xs">
							</i>
						</span>
						<span class="hidden kt-menu-item-show:inline-flex">
							<i class="ki-filled ki-up text-xs">
							</i>
						</span>
					</span>
				</div>
				<div class="kt-menu-accordion gap-px ps-7" style="height: 0px;">
					<div class="kt-menu-item kt-menu-item-accordion" data-kt-menu-item-toggle="accordion" data-kt-menu-item-trigger="click">
						<div class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-item-here:text-mono kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
								Profiles
							</span>
							<span class="kt-menu-arrow text-muted-foreground kt-menu-item-here:text-foreground kt-menu-item-show:text-foreground kt-menu-link-hover:text-foreground">
								<span class="inline-flex kt-menu-item-show:hidden">
									<i class="ki-filled ki-down text-xs">
									</i>
								</span>
								<span class="hidden kt-menu-item-show:inline-flex">
									<i class="ki-filled ki-up text-xs">
									</i>
								</span>
							</span>
						</div>
						<div class="kt-menu-accordion gap-px ps-2.5">
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Default
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Creator
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Company
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										NFT
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Blogger
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										CRM
									</span>
								</a>
							</div>
							<div class="kt-menu-item flex-col-reverse kt-menu-item-accordion" data-kt-menu-item-toggle="accordion" data-kt-menu-item-trigger="click">
								<div class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent">
									<span class="kt-menu-title text-sm text-secondary-foreground kt-menu-item-here:text-foreground kt-menu-item-show:text-foreground kt-menu-link-hover:text-foreground dark:menu-item-here:text-mono dark:menu-item-show:text-mono dark:menu-link-hover:text-mono">
										<span class="hidden kt-menu-item-show:!flex">
											Show less
										</span>
										<span class="flex kt-menu-item-show:hidden">
											Show 4 more
										</span>
									</span>
									<span class="kt-menu-arrow text-muted-foreground kt-menu-item-here:text-foreground kt-menu-item-show:text-foreground kt-menu-link-hover:text-foreground">
										<span class="inline-flex kt-menu-item-show:hidden">
											<i class="ki-filled ki-down text-xs">
											</i>
										</span>
										<span class="hidden kt-menu-item-show:inline-flex">
											<i class="ki-filled ki-up text-xs">
											</i>
										</span>
									</span>
								</div>
								<div class="kt-menu-accordion gap-px">
									<div class="kt-menu-item">
										<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
											<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
												Gamer
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
											<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
												Feeds
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
											<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
												Plain
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
											<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
												Modal
											</span>
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="kt-menu-item kt-menu-item-accordion" data-kt-menu-item-toggle="accordion" data-kt-menu-item-trigger="click">
						<div class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-item-here:text-mono kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
								Projects
							</span>
							<span class="kt-menu-arrow text-muted-foreground kt-menu-item-here:text-foreground kt-menu-item-show:text-foreground kt-menu-link-hover:text-foreground">
								<span class="inline-flex kt-menu-item-show:hidden">
									<i class="ki-filled ki-down text-xs">
									</i>
								</span>
								<span class="hidden kt-menu-item-show:inline-flex">
									<i class="ki-filled ki-up text-xs">
									</i>
								</span>
							</span>
						</div>
						<div class="kt-menu-accordion gap-px ps-2.5">
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										3 Columns
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										2 Columns
									</span>
								</a>
							</div>
						</div>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
								Works
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
								Teams
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
								Network
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
								Activity
							</span>
						</a>
					</div>
					<div class="kt-menu-item flex-col-reverse kt-menu-item-accordion" data-kt-menu-item-toggle="accordion" data-kt-menu-item-trigger="click">
						<div class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent">
							<span class="kt-menu-title text-sm text-secondary-foreground kt-menu-item-here:text-foreground kt-menu-item-show:text-foreground kt-menu-link-hover:text-foreground dark:menu-item-here:text-mono dark:menu-item-show:text-mono dark:menu-link-hover:text-mono">
								<span class="hidden kt-menu-item-show:!flex">
									Show less
								</span>
								<span class="flex kt-menu-item-show:hidden">
									Show 3 more
								</span>
							</span>
							<span class="kt-menu-arrow text-muted-foreground kt-menu-item-here:text-foreground kt-menu-item-show:text-foreground kt-menu-link-hover:text-foreground">
								<span class="inline-flex kt-menu-item-show:hidden">
									<i class="ki-filled ki-down text-xs">
									</i>
								</span>
								<span class="hidden kt-menu-item-show:inline-flex">
									<i class="ki-filled ki-up text-xs">
									</i>
								</span>
							</span>
						</div>
						<div class="kt-menu-accordion gap-px">
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Campaigns - Card
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Campaigns - List
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Empty
									</span>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="kt-menu-item kt-menu-item-accordion" data-kt-menu-item-toggle="accordion" data-kt-menu-item-trigger="click">
				<div class="kt-menu-link gap-2.5 py-2 px-2.5 rounded-md border border-transparent">
					<span class="kt-menu-icon items-start text-secondary-foreground text-lg kt-menu-item-here:text-foreground kt-menu-item-show:text-foreground kt-menu-link-hover:text-foreground dark:menu-item-here:text-mono dark:menu-item-show:text-mono dark:menu-link-hover:text-mono">
						<i class="ki-filled ki-setting-2">
						</i>
					</span>
					<span class="kt-menu-title font-medium text-sm text-foreground kt-menu-item-here:text-mono kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
						My Account
					</span>
					<span class="kt-menu-arrow text-muted-foreground kt-menu-item-here:text-foreground kt-menu-item-show:text-foreground kt-menu-link-hover:text-foreground">
						<span class="inline-flex kt-menu-item-show:hidden">
							<i class="ki-filled ki-down text-xs">
							</i>
						</span>
						<span class="hidden kt-menu-item-show:inline-flex">
							<i class="ki-filled ki-up text-xs">
							</i>
						</span>
					</span>
				</div>
				<div class="kt-menu-accordion gap-px ps-7">
					<div class="kt-menu-item kt-menu-item-accordion" data-kt-menu-item-toggle="accordion" data-kt-menu-item-trigger="click">
						<div class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-item-here:text-mono kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
								Account Home
							</span>
							<span class="kt-menu-arrow text-muted-foreground kt-menu-item-here:text-foreground kt-menu-item-show:text-foreground kt-menu-link-hover:text-foreground">
								<span class="inline-flex kt-menu-item-show:hidden">
									<i class="ki-filled ki-down text-xs">
									</i>
								</span>
								<span class="hidden kt-menu-item-show:inline-flex">
									<i class="ki-filled ki-up text-xs">
									</i>
								</span>
							</span>
						</div>
						<div class="kt-menu-accordion gap-px ps-2.5">
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Get Started
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										User Profile
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Company Profile
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Settings - With Sidebar
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Settings - Enterprise
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Settings - Plain
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Settings - Modal
									</span>
								</a>
							</div>
						</div>
					</div>
					<div class="kt-menu-item kt-menu-item-accordion" data-kt-menu-item-toggle="accordion" data-kt-menu-item-trigger="click">
						<div class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-item-here:text-mono kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
								Billing
							</span>
							<span class="kt-menu-arrow text-muted-foreground kt-menu-item-here:text-foreground kt-menu-item-show:text-foreground kt-menu-link-hover:text-foreground">
								<span class="inline-flex kt-menu-item-show:hidden">
									<i class="ki-filled ki-down text-xs">
									</i>
								</span>
								<span class="hidden kt-menu-item-show:inline-flex">
									<i class="ki-filled ki-up text-xs">
									</i>
								</span>
							</span>
						</div>
						<div class="kt-menu-accordion gap-px ps-2.5">
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Billing - Basic
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Billing - Enterprise
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Plans
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Billing History
									</span>
								</a>
							</div>
						</div>
					</div>
					<div class="kt-menu-item kt-menu-item-accordion" data-kt-menu-item-toggle="accordion" data-kt-menu-item-trigger="click">
						<div class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-item-here:text-mono kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
								Security
							</span>
							<span class="kt-menu-arrow text-muted-foreground kt-menu-item-here:text-foreground kt-menu-item-show:text-foreground kt-menu-link-hover:text-foreground">
								<span class="inline-flex kt-menu-item-show:hidden">
									<i class="ki-filled ki-down text-xs">
									</i>
								</span>
								<span class="hidden kt-menu-item-show:inline-flex">
									<i class="ki-filled ki-up text-xs">
									</i>
								</span>
							</span>
						</div>
						<div class="kt-menu-accordion gap-px ps-2.5">
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Get Started
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Security Overview
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Allowed IP Addresses
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Privacy Settings
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Device Management
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Backup &amp; Recovery
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Current Sessions
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Security Log
									</span>
								</a>
							</div>
						</div>
					</div>
					<div class="kt-menu-item kt-menu-item-accordion" data-kt-menu-item-toggle="accordion" data-kt-menu-item-trigger="click">
						<div class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-item-here:text-mono kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
								Members &amp; Roles
							</span>
							<span class="kt-menu-arrow text-muted-foreground kt-menu-item-here:text-foreground kt-menu-item-show:text-foreground kt-menu-link-hover:text-foreground">
								<span class="inline-flex kt-menu-item-show:hidden">
									<i class="ki-filled ki-down text-xs">
									</i>
								</span>
								<span class="hidden kt-menu-item-show:inline-flex">
									<i class="ki-filled ki-up text-xs">
									</i>
								</span>
							</span>
						</div>
						<div class="kt-menu-accordion gap-px ps-2.5">
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Teams Starter
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Teams
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Team Info
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Members Starter
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Team Members
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Import Members
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Roles
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Permissions - Toggler
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Permissions - Check
									</span>
								</a>
							</div>
						</div>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
								Integrations
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
								Notifications
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
								API Keys
							</span>
						</a>
					</div>
					<div class="kt-menu-item flex-col-reverse kt-menu-item-accordion" data-kt-menu-item-toggle="accordion" data-kt-menu-item-trigger="click">
						<div class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent">
							<span class="kt-menu-title text-sm text-secondary-foreground kt-menu-item-here:text-foreground kt-menu-item-show:text-foreground kt-menu-link-hover:text-foreground dark:menu-item-here:text-mono dark:menu-item-show:text-mono dark:menu-link-hover:text-mono">
								<span class="hidden kt-menu-item-show:!flex">
									Show less
								</span>
								<span class="flex kt-menu-item-show:hidden">
									Show 3 more
								</span>
							</span>
							<span class="kt-menu-arrow text-muted-foreground kt-menu-item-here:text-foreground kt-menu-item-show:text-foreground kt-menu-link-hover:text-foreground">
								<span class="inline-flex kt-menu-item-show:hidden">
									<i class="ki-filled ki-down text-xs">
									</i>
								</span>
								<span class="hidden kt-menu-item-show:inline-flex">
									<i class="ki-filled ki-up text-xs">
									</i>
								</span>
							</span>
						</div>
						<div class="kt-menu-accordion gap-px">
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Appearance
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Invite a Friend
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Activity
									</span>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="kt-menu-item kt-menu-item-accordion" data-kt-menu-item-toggle="accordion" data-kt-menu-item-trigger="click">
				<div class="kt-menu-link gap-2.5 py-2 px-2.5 rounded-md border border-transparent">
					<span class="kt-menu-icon items-start text-secondary-foreground text-lg kt-menu-item-here:text-foreground kt-menu-item-show:text-foreground kt-menu-link-hover:text-foreground dark:menu-item-here:text-mono dark:menu-item-show:text-mono dark:menu-link-hover:text-mono">
						<i class="ki-filled ki-users">
						</i>
					</span>
					<span class="kt-menu-title font-medium text-sm text-foreground kt-menu-item-here:text-mono kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
						Network
					</span>
					<span class="kt-menu-arrow text-muted-foreground kt-menu-item-here:text-foreground kt-menu-item-show:text-foreground kt-menu-link-hover:text-foreground">
						<span class="inline-flex kt-menu-item-show:hidden">
							<i class="ki-filled ki-down text-xs">
							</i>
						</span>
						<span class="hidden kt-menu-item-show:inline-flex">
							<i class="ki-filled ki-up text-xs">
							</i>
						</span>
					</span>
				</div>
				<div class="kt-menu-accordion gap-px ps-7">
					<div class="kt-menu-item">
						<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
								Get Started
							</span>
						</a>
					</div>
					<div class="kt-menu-item kt-menu-item-accordion" data-kt-menu-item-toggle="accordion" data-kt-menu-item-trigger="click">
						<div class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-item-here:text-mono kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
								User Cards
							</span>
							<span class="kt-menu-arrow text-muted-foreground kt-menu-item-here:text-foreground kt-menu-item-show:text-foreground kt-menu-link-hover:text-foreground">
								<span class="inline-flex kt-menu-item-show:hidden">
									<i class="ki-filled ki-down text-xs">
									</i>
								</span>
								<span class="hidden kt-menu-item-show:inline-flex">
									<i class="ki-filled ki-up text-xs">
									</i>
								</span>
							</span>
						</div>
						<div class="kt-menu-accordion gap-px ps-2.5">
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Mini Cards
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Team Crew
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Author
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										NFT
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Social
									</span>
								</a>
							</div>
						</div>
					</div>
					<div class="kt-menu-item kt-menu-item-accordion" data-kt-menu-item-toggle="accordion" data-kt-menu-item-trigger="click">
						<div class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-item-here:text-mono kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
								User Table
							</span>
							<span class="kt-menu-arrow text-muted-foreground kt-menu-item-here:text-foreground kt-menu-item-show:text-foreground kt-menu-link-hover:text-foreground">
								<span class="inline-flex kt-menu-item-show:hidden">
									<i class="ki-filled ki-down text-xs">
									</i>
								</span>
								<span class="hidden kt-menu-item-show:inline-flex">
									<i class="ki-filled ki-up text-xs">
									</i>
								</span>
							</span>
						</div>
						<div class="kt-menu-accordion gap-px ps-2.5">
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Team Crew
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										App Roster
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Market Authors
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										SaaS Users
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Store Clients
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Visitors
									</span>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="kt-menu-item kt-menu-item-accordion" data-kt-menu-item-toggle="accordion" data-kt-menu-item-trigger="click">
				<div class="kt-menu-link gap-2.5 py-2 px-2.5 rounded-md border border-transparent">
					<span class="kt-menu-icon items-start text-secondary-foreground text-lg kt-menu-item-here:text-foreground kt-menu-item-show:text-foreground kt-menu-link-hover:text-foreground dark:menu-item-here:text-mono dark:menu-item-show:text-mono dark:menu-link-hover:text-mono">
						<i class="ki-filled ki-security-user">
						</i>
					</span>
					<span class="kt-menu-title font-medium text-sm text-foreground kt-menu-item-here:text-mono kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
						Authentication
					</span>
					<span class="kt-menu-arrow text-muted-foreground kt-menu-item-here:text-foreground kt-menu-item-show:text-foreground kt-menu-link-hover:text-foreground">
						<span class="inline-flex kt-menu-item-show:hidden">
							<i class="ki-filled ki-down text-xs">
							</i>
						</span>
						<span class="hidden kt-menu-item-show:inline-flex">
							<i class="ki-filled ki-up text-xs">
							</i>
						</span>
					</span>
				</div>
				<div class="kt-menu-accordion gap-px ps-7">
					<div class="kt-menu-item kt-menu-item-accordion" data-kt-menu-item-toggle="accordion" data-kt-menu-item-trigger="click">
						<div class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-item-here:text-mono kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
								Classic
							</span>
							<span class="kt-menu-arrow text-muted-foreground kt-menu-item-here:text-foreground kt-menu-item-show:text-foreground kt-menu-link-hover:text-foreground">
								<span class="inline-flex kt-menu-item-show:hidden">
									<i class="ki-filled ki-down text-xs">
									</i>
								</span>
								<span class="hidden kt-menu-item-show:inline-flex">
									<i class="ki-filled ki-up text-xs">
									</i>
								</span>
							</span>
						</div>
						<div class="kt-menu-accordion gap-px ps-2.5">
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Sign In
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Sign Up
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										2FA
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Check Email
									</span>
								</a>
							</div>
							<div class="kt-menu-item kt-menu-item-accordion" data-kt-menu-item-toggle="accordion" data-kt-menu-item-trigger="click">
								<div class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-item-here:text-mono kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
										Reset Password
									</span>
									<span class="kt-menu-arrow text-muted-foreground kt-menu-item-here:text-foreground kt-menu-item-show:text-foreground kt-menu-link-hover:text-foreground">
										<span class="inline-flex kt-menu-item-show:hidden">
											<i class="ki-filled ki-down text-xs">
											</i>
										</span>
										<span class="hidden kt-menu-item-show:inline-flex">
											<i class="ki-filled ki-up text-xs">
											</i>
										</span>
									</span>
								</div>
								<div class="kt-menu-accordion gap-px ps-2.5">
									<div class="kt-menu-item">
										<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
											<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
												Enter Email
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
											<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
												Check Email
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
											<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
												Change Password
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
											<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
												Password is Changed
											</span>
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="kt-menu-item kt-menu-item-accordion" data-kt-menu-item-toggle="accordion" data-kt-menu-item-trigger="click">
						<div class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-item-here:text-mono kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
								Branded
							</span>
							<span class="kt-menu-arrow text-muted-foreground kt-menu-item-here:text-foreground kt-menu-item-show:text-foreground kt-menu-link-hover:text-foreground">
								<span class="inline-flex kt-menu-item-show:hidden">
									<i class="ki-filled ki-down text-xs">
									</i>
								</span>
								<span class="hidden kt-menu-item-show:inline-flex">
									<i class="ki-filled ki-up text-xs">
									</i>
								</span>
							</span>
						</div>
						<div class="kt-menu-accordion gap-px ps-2.5">
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Sign In
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Sign Up
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										2FA
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Check Email
									</span>
								</a>
							</div>
							<div class="kt-menu-item kt-menu-item-accordion" data-kt-menu-item-toggle="accordion" data-kt-menu-item-trigger="click">
								<div class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-item-here:text-mono kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
										Reset Password
									</span>
									<span class="kt-menu-arrow text-muted-foreground kt-menu-item-here:text-foreground kt-menu-item-show:text-foreground kt-menu-link-hover:text-foreground">
										<span class="inline-flex kt-menu-item-show:hidden">
											<i class="ki-filled ki-down text-xs">
											</i>
										</span>
										<span class="hidden kt-menu-item-show:inline-flex">
											<i class="ki-filled ki-up text-xs">
											</i>
										</span>
									</span>
								</div>
								<div class="kt-menu-accordion gap-px ps-2.5">
									<div class="kt-menu-item">
										<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
											<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
												Enter Email
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
											<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
												Check Email
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
											<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
												Change Password
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
											<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
												Password is Changed
											</span>
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
								Welcome Message
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
								Account Deactivated
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
								Error 404
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
								Error 500
							</span>
						</a>
					</div>
				</div>
			</div>
			<div class="kt-menu-item kt-menu-item-accordion" data-kt-menu-item-toggle="accordion" data-kt-menu-item-trigger="click">
				<div class="kt-menu-link gap-2.5 py-2 px-2.5 rounded-md border border-transparent">
					<span class="kt-menu-icon items-start text-secondary-foreground text-lg kt-menu-item-here:text-foreground kt-menu-item-show:text-foreground kt-menu-link-hover:text-foreground dark:menu-item-here:text-mono dark:menu-item-show:text-mono dark:menu-link-hover:text-mono">
						<i class="ki-filled ki-users">
						</i>
					</span>
					<span class="kt-menu-title font-medium text-sm text-foreground kt-menu-item-here:text-mono kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
						Store - Client
					</span>
					<span class="kt-menu-arrow text-muted-foreground kt-menu-item-here:text-foreground kt-menu-item-show:text-foreground kt-menu-link-hover:text-foreground">
						<span class="inline-flex kt-menu-item-show:hidden">
							<i class="ki-filled ki-down text-xs">
							</i>
						</span>
						<span class="hidden kt-menu-item-show:inline-flex">
							<i class="ki-filled ki-up text-xs">
							</i>
						</span>
					</span>
				</div>
				<div class="kt-menu-accordion gap-px ps-7">
					<div class="kt-menu-item">
						<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
								Home
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
								Search Results - Grid
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
								Search Results - List
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
								Product Details
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
								Shopping Cart
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
								Wishlist
							</span>
						</a>
					</div>
					<div class="kt-menu-item kt-menu-item-accordion" data-kt-menu-item-toggle="accordion" data-kt-menu-item-trigger="click">
						<div class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-item-here:text-mono kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
								Checkout
							</span>
							<span class="kt-menu-arrow text-muted-foreground kt-menu-item-here:text-foreground kt-menu-item-show:text-foreground kt-menu-link-hover:text-foreground">
								<span class="inline-flex kt-menu-item-show:hidden">
									<i class="ki-filled ki-down text-xs">
									</i>
								</span>
								<span class="hidden kt-menu-item-show:inline-flex">
									<i class="ki-filled ki-up text-xs">
									</i>
								</span>
							</span>
						</div>
						<div class="kt-menu-accordion gap-px ps-2.5">
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Order Summary
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Shipping Info
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Payment Method
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
									<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
										Order Placed
									</span>
								</a>
							</div>
						</div>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
								My Orders
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link py-2 px-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
							<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
								Order Receipt
							</span>
						</a>
					</div>
				</div>
			</div>
		</div>
		<!-- End of Primary Menu -->
		<div class="border-b border-input mt-4 mb-1 mx-3.5">
		</div>
		<!-- Secondary Menu -->
		<div class="kt-menu flex flex-col w-full gap-1.5 px-3.5" data-kt-menu="true" data-kt-menu-accordion-expand-all="true" id="sidebar_secondary_menu">
			<div class="kt-menu-item show kt-menu-item-accordion" data-kt-menu-item-toggle="accordion" data-kt-menu-item-trigger="click">
				<div class="kt-menu-label flex items-center justify-between">
					<div class="kt-menu-toggle cursor-pointer pb-2 pt-3 ps-[14.5px] rounded-md border border-transparent">
						<span class="kt-menu-arrow me-2.5">
							<span class="inline-flex kt-menu-item-show:hidden">
								<i class="ki-filled ki-down text-xs">
								</i>
							</span>
							<span class="hidden kt-menu-item-show:inline-flex">
								<i class="ki-filled ki-up text-xs">
								</i>
							</span>
						</span>
						<span class="kt-menu-title text-sm text-foreground font-medium">
							Spaces
						</span>
					</div>
					<a class="kt-btn kt-btn-ghost kt-btn-sm kt-btn-icon kt-btn-icon-sm text-muted-foreground hover:text-foreground me-1.25" href="#">
						<i class="ki-filled ki-plus">
						</i>
					</a>
				</div>
				<div class="kt-menu-accordion">
					<div class="kt-menu-item">
						<a class="kt-menu-link py-1 px-2 my-0.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
							<span class="kt-menu-icon text-secondary-foreground kt-menu-link-hover:text-mono rounded-md flex place-content-center size-7 me-2.5 bg-border border border-input kt-menu-item-active:border-none kt-menu-link-hover:border-light kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-none dark:menu-item-active:text-mono kt-menu-icon-xs">
								<i class="ki-filled ki-abstract-26">
								</i>
							</span>
							<span class="kt-menu-title text-sm text-secondary-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
								Metrics Hub
							</span>
						</a>
					</div>
					<div class="kt-menu-item active">
						<a class="kt-menu-link py-1 px-2 my-0.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
							<span class="kt-menu-icon text-secondary-foreground kt-menu-link-hover:text-mono rounded-md flex place-content-center size-7 me-2.5 bg-border border border-input kt-menu-item-active:border-none kt-menu-link-hover:border-light kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-none dark:menu-item-active:text-mono kt-menu-icon-xs">
								<i class="ki-filled ki-abstract-41">
								</i>
							</span>
							<span class="kt-menu-title text-sm text-secondary-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
								Data Lab
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link py-1 px-2 my-0.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
							<span class="kt-menu-icon text-secondary-foreground kt-menu-link-hover:text-mono rounded-md flex place-content-center size-7 me-2.5 bg-border border border-input kt-menu-item-active:border-none kt-menu-link-hover:border-light kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-none dark:menu-item-active:text-mono kt-menu-icon-xs">
								<i class="ki-filled ki-abstract-39">
								</i>
							</span>
							<span class="kt-menu-title text-sm text-secondary-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
								Creative Commons
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link py-1 px-2 my-0.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
							<span class="kt-menu-icon text-secondary-foreground kt-menu-link-hover:text-mono rounded-md flex place-content-center size-7 me-2.5 bg-border border border-input kt-menu-item-active:border-none kt-menu-link-hover:border-light kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-none dark:menu-item-active:text-mono kt-menu-icon-xs">
								<i class="ki-filled ki-abstract-35">
								</i>
							</span>
							<span class="kt-menu-title text-sm text-secondary-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
								KPI Monitor
							</span>
						</a>
					</div>
				</div>
			</div>
			<div class="border-b border-input mt-2 mb-1 mx-1.5">
			</div>
			<div class="kt-menu-item kt-menu-item-accordion" data-kt-menu-item-toggle="accordion" data-kt-menu-item-trigger="click">
				<div class="kt-menu-label flex items-center justify-between">
					<div class="kt-menu-toggle cursor-pointer pb-2 pt-3 ps-[14.5px] rounded-md border border-transparent">
						<span class="kt-menu-arrow me-2.5">
							<span class="inline-flex kt-menu-item-show:hidden">
								<i class="ki-filled ki-down text-xs">
								</i>
							</span>
							<span class="hidden kt-menu-item-show:inline-flex">
								<i class="ki-filled ki-up text-xs">
								</i>
							</span>
						</span>
						<span class="kt-menu-title text-sm text-foreground font-medium">
							Favorites
						</span>
					</div>
				</div>
				<div class="kt-menu-accordion">
					<div class="kt-menu-item">
						<a class="kt-menu-link py-1 px-2 my-0.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
							<span class="kt-menu-icon text-secondary-foreground kt-menu-link-hover:text-mono rounded-md flex place-content-center size-7 me-2.5 bg-border border border-input kt-menu-item-active:border-none kt-menu-link-hover:border-light kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-none dark:menu-item-active:text-mono kt-menu-icon-xs">
								<i class="ki-filled ki-badge">
								</i>
							</span>
							<span class="kt-menu-title text-sm text-secondary-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
								Post Date
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link py-1 px-2 my-0.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
							<span class="kt-menu-icon text-secondary-foreground kt-menu-link-hover:text-mono rounded-md flex place-content-center size-7 me-2.5 bg-border border border-input kt-menu-item-active:border-none kt-menu-link-hover:border-light kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-none dark:menu-item-active:text-mono kt-menu-icon-xs">
								<i class="ki-filled ki-cheque">
								</i>
							</span>
							<span class="kt-menu-title text-sm text-secondary-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
								Creative Licenses
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link py-1 px-2 my-0.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
							<span class="kt-menu-icon text-secondary-foreground kt-menu-link-hover:text-mono rounded-md flex place-content-center size-7 me-2.5 bg-border border border-input kt-menu-item-active:border-none kt-menu-link-hover:border-light kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-none dark:menu-item-active:text-mono kt-menu-icon-xs">
								<i class="ki-filled ki-users">
								</i>
							</span>
							<span class="kt-menu-title text-sm text-secondary-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
								Open Content
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link py-1 px-2 my-0.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
							<span class="kt-menu-icon text-secondary-foreground kt-menu-link-hover:text-mono rounded-md flex place-content-center size-7 me-2.5 bg-border border border-input kt-menu-item-active:border-none kt-menu-link-hover:border-light kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-none dark:menu-item-active:text-mono kt-menu-icon-xs">
								<i class="ki-filled ki-security-user">
								</i>
							</span>
							<span class="kt-menu-title text-sm text-secondary-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-mono kt-menu-link-hover:text-mono">
								Copyright
							</span>
						</a>
					</div>
				</div>
			</div>
		</div>
		<!-- End of Secondary Menu -->

	</div>
</div>